import { IconProps } from "./lib/types";

/* ── Solid shapes (current / default / color-blind mode) ─────── */

const CircleIcon = ({color, width = 24, height = 24}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    fill={`${color || "#000"}`}
    viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12"/>
  </svg>
)

const ArrowUpIcon = ({ color, width = 24, height = 24 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    fill={`${color || "#000"}`}
    viewBox="0 0 1024 1024">
    <path d="M42.666667 896 981.333333 896 512 85.333333Z"/>
  </svg>
)

const ArrowDownIcon = ({color, width = 24, height = 24}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    fill={`${color || "#000"}`}
    viewBox="0 0 1024 1024">
    <path d="M42.666667 85.333333 981.333333 85.333333 512 896Z"/>
  </svg>
)

/* ── Duotone halo shapes (normal vision, non-color-blind) ────── */
/*
 * Each shape has a faint outer halo (opacity 0.18) and a solid inner core.
 * Pulse animation is handled externally by wrapping the icon in an HTML
 * <span class="kpi-pulse-wrapper"> (see kpi-animations.css).
 */

const DuotoneCircleIcon = ({ color, width = 24, height = 24 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    viewBox="0 0 24 24"
    style={{ overflow: 'visible' }}
  >
    <circle cx="12" cy="12" r="12"
      fill={`${color || "#000"}`} opacity="0.18"
    />
    <circle cx="12" cy="12" r="8.5" fill={`${color || "#000"}`} />
  </svg>
)

const DuotoneArrowUpIcon = ({ color, width = 24, height = 24 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    viewBox="0 0 24 24"
    style={{ overflow: 'visible' }}
  >
    <path d="M12 0 L24 22 L0 22 Z"
      fill={`${color || "#000"}`} opacity="0.18"
    />
    <path d="M12 4 L20.5 20 L3.5 20 Z" fill={`${color || "#000"}`} />
  </svg>
)

const DuotoneArrowDownIcon = ({ color, width = 24, height = 24 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}`}
    height={`${height}`}
    viewBox="0 0 24 24"
    style={{ overflow: 'visible' }}
  >
    <path d="M12 24 L24 2 L0 2 Z"
      fill={`${color || "#000"}`} opacity="0.18"
    />
    <path d="M12 20 L20.5 4 L3.5 4 Z" fill={`${color || "#000"}`} />
  </svg>
)

export {
  CircleIcon, ArrowUpIcon, ArrowDownIcon,
  DuotoneCircleIcon, DuotoneArrowUpIcon, DuotoneArrowDownIcon,
}